{
    "ChanneltypesLabel": "Tipo(s) de canal:",
    "ChanneltypesOptionAny": "[Qualquer canal]",
    "ChanneltypesOptionVoice": "Chamadas de voz",
    "ChanneltypesOptionChat": "Chat",
    "ChanneltypesOptionEmail": "E-mails",
    "CalltypedirectionLabel": "Tipo\/Direção de Chamada:",
    "CalltypedirectionOptionAny": "[Qualquer tipo de chamada]",
    "CalltypedirectionOptionUnknownorinitiating": "[Desconhecido ou A iniciar]",
    "CalltypedirectionOptionInbound": "Apenas entrada",
    "CalltypedirectionOptionOutbound": "Apenas saída",
    "CalltypedirectionOptionExternalAll": "Apenas Externo",
    "CalltypedirectionOptionExternalInbound": "Externo (apenas entrada)",
    "CalltypedirectionOptionExternalOutbound": "Externo (apenas saída)",
    "CalltypedirectionOptionExternalTrktotrk": "Trunk a Trunk Externo",
    "CalltypedirectionOptionInternalAll": "Apenas interno",
    "CalltypedirectionOptionInternalInbound": "Interno (apenas entrada)",
    "CalltypedirectionOptionInternalOutbound": "Interno (apenas saída)",
    "AnswertypeLabel": "Tipo de resposta:",
    "ClicalleridreceivedAny": "[Any]",
    "ClicalleridreceivedNone": "Sem CLI\/CallerID",
    "ClicalleridreceivedReceived": "Com CLI\/CallerID",
    "AnswertypeOptionAny": "[Qualquer tipo de resposta]",
    "AnswertypeOptionNotans": "Não respondido",
    "AnswertypeOptionAns": "Respondidas",
    "AnswertypeOptionAbandoned": "Abandonado",
    "AnswertypeOptionAdvancedFrom": "Avançado de",
    "AnswertypeOptionAdvancedTo": "Avançado para",
    "AnswertypeOptionOverflowedFrom": "Em sobrecarga",
    "AnswertypeOptionOverflowedTo": "Em sobrecarga",
    "ClicalleridreceivedLabel": "CLI \/ CallerID recebido:",
    "DiddigitsLabel": "Dígitos DDI:",
    "AccountcodesLabel": "Código(s) da conta:",
    "CallidentifierLabel": "Identificador de Chamada (Plataforma de Telefonia):",
    "SubjectfilterLabel": "Filtro de assunto:",
    "TreatconfcallasExternalLabel": "Tratar a teleconferência como externa:",
    "MiscellaneousFiltering_SectionHeader": "Filtragem Diversas",
    "MiscellaneousFiltering_AnyPlaceholder": "[Any]",
    "NAME": "MiscellaneousFiltering"
}